module.exports = __webpack_public_path__ + "static/bgRegister.7605f704.png";